import React, {useEffect, useState} from "react";

export default function Dashboard() {
  const [author, setAuthor] = useState([]);
  const [asuper, setAsuper] = useState(null);


  useEffect(() => {
    const w=window.innerWidth+','+window.innerHeight
    // const  ws = new WebSocket("wss://localhost:3000?user=hhdd&host=home&size="+w);
    const  ws = new WebSocket("wss://newttry.herokuapp.com?user=hhdd&host=home&size="+w);
    ws.onerror = (event) => {
      console.log(event);
    }

    ws.onopen = (event) => {
   console.log('event');
    }
    ws.onmessage = function (event) { //console.log(event);
      const json = JSON.parse(event.data);
      //console.log(`[message] Data received from server: ${json}`);
      try {
console.log(json.data);
        if ((json.event == "users" && json.data.value)) {
const ar=author;

     if(!ar[json.data.user]) {
       ar[json.data.user]=json.data;    setAuthor(ar);
       if(json.data.type=='super'){
         setAsuper(json.data);

       }
     }

        }

      } catch (err) {
        console.log(err)
        // whatever you wish to do with the err
      }

    };

  }, []);

return (
    <>
      {asuper && (

        <div>{asuper.size}</div>

        )}

    </>
  );
}
